import React from 'react'
import { motion } from "framer-motion"


const Info = ({ showAllergens, handleShowAllergensClick }) => {


    return (

        <motion.div
            initial={false}
            animate={{ height: showAllergens ? 1350 : 0 }}

           

            className={showAllergens ? `flex flex-row font-mono    bg-beigeOne items-center  text-greenTwo` : 'invisible '}>
            {showAllergens &&
                <>
                    <div className='flex flex-col  text-center text-sm w-12/12 ml-2'>
                        <p>
                            (1)Зърнени култури, съдържащи глутен, а именно: пшеница, ръж, ечемик, овес, шпелта (вид пшеница), камут (вид едра твърда пшеница) или техни хибридни сортове, както и продукти от тях, с изключение на:
                            а)	глюкозен сироп на пшенична основа, включително декстроза (1);
                            б)	малтодекстрини на пшенична основа (1);
                            в)	глюкозен сироп на ечемична основа;
                            г)	зърнени култури, използвани за производство на алкохолни дестилати, включително етилов алкохол от селскостопански произход;
                            <br></br>
                            (2)Ракообразни и продукти от тях;
                            <br></br>
                            (3)Яйца и продукти от тях.
                            <br></br>
                            (4)Риба и рибни продукти, с изключение на:
                            а)	рибен желатин, използван като носител на витамини или каротиноидни заготовки;
                            б)	рибен желатин или рибен клей, използван като подобряващ агент в бира и вино;
                            <br></br>
                            (5)Фъстъци и продукти от тях;
                            <br></br>
                            (6)Соя и соеви продукти, с изключение на:
                            а)	напълно рафинирани соево масло и мазнина (1);
                            б)	натурални смесени токофероли (Е306), натурален D-алфа токоферол, натурален D-алфа токоферолацетат, натурален D-алфа токоферолсукцинат от соеви източници;
                            в)	фитостероли и фитостеролови естери от растителни масла, получени от соеви.източници;
                            г)	растителен станолов естер, произведен от стероли на растителни масла от соеви източници;
                            <br></br>
                            (7)Мляко и млечни продукти (включително лактоза), с изключение на:
                            а)	суроватка, използвана за производство на алкохолни дестилати, включително етилов алкохол от селскостопански
                            произход;
                            б)	лактитол;
                            <br></br>
                            (8)Ядки, а именно: бадеми (Amygdaluscommunis L.), лешници (Corylusavellana), орехи (Juglansregia), кашу(Anacardiumoccidentale), пеканови ядки (Caryaillinoiesis (Wangenh.)K. Koch), бразилски орехи (Bertholletiaexcelsa), шамфъстък(Р181аша vera), орехи макадамия или орехи Куинсленд(Macadamia temifolia) и продукти от тях, с изключение на ядки, използвани за производство на алкохолни дестилати, включително етилов алкохол от селскостопански произход:
                            <br></br>
                            (9)Целина и продукти от нея;
                            <br></br>
                            (10)Синап и продукти от него;
                            <br></br>
                            (11)Сусамово семе и продукти от него;
                            <br></br>
                            (12)Серен диоксид и сулфити с концентрация над 10 mg/kg или 10 mg/litre,                .    изразени под формата на общ S02, който следва да се изчисли за продуктите,                .   предлагани готови за консумация или върнати към първоначално състояние             .     съгласно указанията на производителя;
                            <br></br>
                            (13)Лупина(род едногодишни или многогодишни растения от семейство                    .     Бобови) и продукти от нея;
                            <br></br>
                            (14)Мекотели и продукти от тях

                        </p>
                        <div className='text-sm mt-4 p-1 m-1 w-1/2 m-auto cursor-pointer align-self-center text-red border-2 border-b-red rounded-md'
                        onClick={() => handleShowAllergensClick()}
                    > <p className='p-1'>Скрий Алергените!</p>
                    </div>
                    </div>
                </>}
        </motion.div>
    )
}

export default Info